import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Select, notification, Row, Col, Input, InputNumber } from 'antd';
import { CONSTANTS_REQ } from '../../utils/Constants';
import { geti18nText, NyRequestResolver, NySearchField, NySession, RESPONSE } from '@nybble/nyreact';

const UpdateLights = (props: any) => {
    const [visible, setVisible] = useState(false);
    const [hasSelected, setHasSelected] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    const [form] = Form.useForm();

    useEffect(() => {
        setHasSelected(props.hasSelected);
        setSelectedRowKeys(props.selectedRowKeys);
    }, [props]);

    const showModal = () => {
        setVisible(true);
    };

    const handleCancel = (e: any) => {
        form.resetFields();
        setVisible(false);
    };

    function okNotification() {
        notification.success({
            message: geti18nText('app.default.save.ok'),
            description: geti18nText('app.default.save.ok.desc'),
            duration: 3,
        });
    }

    const onSubmit = (e: any) => {
        e.preventDefault();
        NyRequestResolver.requestPost(CONSTANTS_REQ.LIGHT.UPDATE_LIGHTS, undefined, {
            projectId: NySession.getProjectId(),
            lightIds: selectedRowKeys,
            ...normalize(form.getFieldsValue()),
        }).then((result) => {
            if (result.status === RESPONSE.CREATED) {
                form.resetFields();
                props.onPopupSave();
                props.clearSelectedRowKeys();
                setSelectedRowKeys([]);
                setHasSelected(false);
                setVisible(false);
                okNotification();
            }
        });
    };

    function normalize(values: any) {
        for (var key in values) {
            if (values.hasOwnProperty(key) && values[key] != 0) {
                if (values[key] == '' || (values[key] instanceof Object && values[key].id <= 0)) {
                    values[key] = undefined;
                }
            }
        }
        if (values.device) {
            values.deviceId = values.device.id;
            values.device = undefined;
        }
        if (values.substation) {
            values.substationId = values.substation.id;
            values.substation = undefined;
        }
        return values;
    }

    return (
        <React.Fragment>
            <Button
                disabled={!hasSelected}
                type="primary"
                onClick={showModal}
                style={{ float: 'left', marginLeft: '1.5em' }}
            >
                {geti18nText('lights.table.updateLights')}
            </Button>

            <Modal
                title={geti18nText('lights.table.updateLights')}
                visible={visible}
                onCancel={handleCancel}
                onOk={onSubmit}
                okText={geti18nText('lights.table.updateLights')}
                destroyOnClose
            >
                <label style={{ color: 'red' }}>{geti18nText('lights.table.updateLights.empty')}</label>
                <Form layout="vertical" form={form}>
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item label={geti18nText('lights.edit.street')} name="street">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={geti18nText('lights.edit.town')} name="town">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={geti18nText('lights.edit.type')} name="type">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={geti18nText('lights.edit.power')} name="power">
                                <InputNumber
                                    style={{ width: '100%' }}
                                    formatter={(value) => `${value}`.replace(/(\.[^]+)|([^0-9])/g, '')}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={geti18nText('lights.edit.tolerance')} name="powerTolerance">
                                <InputNumber
                                    style={{ width: '100%' }}
                                    formatter={(value) => `${value}`.replace(/(\.[^]+)|([^0-9])/g, '')}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={geti18nText('lights.edit.dimming')} name="dimming">
                                <InputNumber
                                    style={{ width: '100%' }}
                                    min={0}
                                    max={100}
                                    formatter={(value) => `${value}`.replace(/(\.[^]+)|([^0-9])/g, '')}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={geti18nText('lights.edit.device')} name="device">
                                <NySearchField
                                    url={CONSTANTS_REQ.DEVICE.SEARCH}
                                    map={{ id: 'id', label: 'text' }}
                                    searchBy="name"
                                    disabled={false}
                                    addedFilter={{
                                        field: 'project_id',
                                        condition: 'equals',
                                        value: NySession.getProjectId(),
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={geti18nText('lights.edit.substation')} name="substation">
                                <NySearchField
                                    url={CONSTANTS_REQ.SUBSTATION.SEARCH}
                                    map={{ id: 'id', label: 'text' }}
                                    searchBy="substationId"
                                    disabled={false}
                                    addedFilter={{
                                        field: 'project_id',
                                        condition: 'equals',
                                        value: NySession.getProjectId(),
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={geti18nText('lights.edit.numLights')} name="numLights">
                                <InputNumber
                                    style={{ width: '100%' }}
                                    formatter={(value) => `${value}`.replace(/(\.[^]+)|([^0-9])/g, '')}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={geti18nText('lights.edit.regime')} name="regime">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={geti18nText('lights.edit.phase')} name="phase">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="activate" label={geti18nText('lights.edit.status')}>
                                <Select allowClear>
                                    <Select.Option value="true">
                                        {geti18nText('lights.edit.status.activate')}
                                    </Select.Option>
                                    <Select.Option value="false">
                                        {geti18nText('lights.edit.status.deactivate')}
                                    </Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </React.Fragment>
    );
};

export default UpdateLights;
